import API from "./axios";

/* =========================
   ADD TO CART
========================= */
export const addToCartApi = (data) =>  API.post("/cart/add", data);


/* =========================
   UPDATE QUANTITY
========================= */
export const updateCartQuantityApi = (data) =>  API.put("/cart/update", data);


/* =========================
   REMOVE ITEM
========================= */
export const removeFromCartApi = (productId) =>  API.delete(`/cart/remove/${productId}`);


/* =========================
   GET CART
========================= */
export const getCartApi = () =>  API.get("/cart");


/* =========================
   CLEAR CART
========================= */
export const clearCartApi = () =>  API.delete("/cart/clear");